import { apiFetch } from "./api";

export type ExpertCategory =
  | "juridique"
  | "tech"
  | "marche"
  | "fonctions"
  | string;

export type ExpertKnowledgeSourceItem = {
  title?: string;
  url?: string;
  description?: string;
  [k: string]: unknown;
};

export type ExpertKnowledgeLayer = {
  name: string;
  items: ExpertKnowledgeSourceItem[];
};

export type Expert = {
  slug: string;
  name: string;
  category: ExpertCategory;
  icon?: string | null;
  short_description: string;
  long_description?: string;
  years_expertise?: number;
  documents_count?: number;
  llm?: string;
  knowledge_sources?: ExpertKnowledgeLayer[];
};

export type ExpertRecommendation = {
  slug: string;
  name?: string;
  icon?: string | null;
  category?: ExpertCategory;
  justification: string;
  priority: 1 | 2 | 3;
};

export type RecommendResponse = {
  recommendations: ExpertRecommendation[];
};

export type CatalogueResponse = {
  experts: Expert[];
};

export async function fetchCatalogue(): Promise<Expert[]> {
  const res = await apiFetch<CatalogueResponse | Expert[]>(
    "/api/experts/catalogue",
  );
  if (Array.isArray(res)) return res;
  return res?.experts ?? [];
}

export async function fetchExpert(slug: string): Promise<Expert> {
  const res = await apiFetch<Expert | { expert: Expert }>(
    `/api/experts/${encodeURIComponent(slug)}`,
  );
  return (res as { expert?: Expert }).expert ?? (res as Expert);
}

export async function recommendCouncil(
  question: string,
  mode = "produit",
): Promise<ExpertRecommendation[]> {
  const res = await apiFetch<RecommendResponse>("/api/council/recommend", {
    method: "POST",
    body: JSON.stringify({ question, mode }),
  });
  return res.recommendations ?? [];
}

export const EXPERT_CATEGORIES: { value: string; label: string }[] = [
  { value: "all", label: "Toutes" },
  { value: "juridique", label: "Juridique" },
  { value: "tech", label: "Tech" },
  { value: "marche", label: "Marché" },
  { value: "fonctions", label: "Fonctions" },
];

export function categoryLabel(c: string): string {
  return (
    EXPERT_CATEGORIES.find((x) => x.value === c)?.label ??
    c.charAt(0).toUpperCase() + c.slice(1)
  );
}
